import { render, staticRenderFns } from "./MenuUserNotes.vue?vue&type=template&id=ec3a4b4e"
import script from "./MenuUserNotes.js?vue&type=script&lang=js&external"
export * from "./MenuUserNotes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports